<script setup>
  import PersonComponent from "@/Components/Person/PersonComponent.vue";
  import TasksPendingUserDashComponent from "@/Components/TasksPending/TasksPendingUserDashComponent.vue";
  import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="Permissions.checkPermissions(['users.list'])">
        <PersonComponent/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['tasks-pending.list-user'])">
        <TasksPendingUserDashComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>